import { createFileRoute } from '@tanstack/react-router'
import TicketSubmitCompletedPage from '@/spa/pages/TicketSubmitCompletedPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/ticket-submit/$id/completed')({
  component: TicketSubmitCompletedPage,
  errorComponent: routeErrorComponent,
})
